import { CITY } from '@city'
import { ConsentRecordCookies } from './ConsentRecordCookies'
import { showConsentWindow } from '../../cookie/inMobiChoice'

/**
 * The cookie policy of a city without web analytics (`CITY.webAnalytics`
 * false): no analytics cookies. The consent window still runs (wherever the
 * site may show ads), so the cookies that record its answer are listed, with the
 * button to change it. What else the site keeps lives in the browser's own
 * storage and never leaves the device.
 */
export function CookieFreePolicy() {
  return (
    <>
      <p>{CITY.domain} runs no analytics and sets no analytics cookies.</p>

      <h2>Strictly necessary</h2>
      <p>The site asks for your cookie consent, and keeps the answer in these cookies:</p>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th align="left">Name</th>
            <th align="left">Purpose</th>
            <th align="left">Retention</th>
          </tr>
        </thead>
        <tbody>
          <ConsentRecordCookies />
        </tbody>
      </table>

      <h2>What stays in your browser</h2>
      <p>
        To work offline and remember your choices, the site keeps your recent searches, favourite
        stations, saved and recent routes, and the downloaded map in your browser&apos;s storage.
        They stay on your device and are never sent to us. Clearing the site data in your browser
        removes them.
      </p>

      <h2>Change your choice</h2>
      <p>
        <button type="button" onClick={showConsentWindow}>
          Open cookie settings
        </button>
      </p>
    </>
  )
}
